import { useEffect } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { setAddedDevices, setRemovedDevices } from '#action/project/devices-popup';
import { getSymmetricDifference, getDeviceDiff } from '#component/device/devices-popup/helper';

export const useFloatDevicesSyncAppliance = (
  formDataObj,
  openedFromForm,
  addMode,
  renderRef,
  emptyForm,
  refetchDataRef,
  formDevicesProp
) => {
  const {
    projectId, groupData, formDevices: dataFormDevices
  } = formDataObj || {};

  const dispatch = useDispatch();
  const popupFormDevices = useSelector(s => s.projectDevicesPopup?.formDevices, shallowEqual);

  const formInitialValues = groupData?.devices || [];
  const formDevices = formDevicesProp || dataFormDevices || popupFormDevices || [];

  const formDevicesJson = JSON.stringify(formDevices);
  const formInitialValuesJson = JSON.stringify(formInitialValues);

  useEffect(() => {
    if (!openedFromForm || !projectId || emptyForm) {
      refetchDataRef.current = true;
      return;
    }

    if (!formInitialValues || !formDevices?.length) {
      return;
    }

    const symmetricDiff = getSymmetricDifference(formDevices, formInitialValues);
    const isDevicesWasReplaced = formDevices?.length === formInitialValues?.length &&
      symmetricDiff.length;

    if (isDevicesWasReplaced && !addMode) {
      const devicesDiff = getDeviceDiff(formDevices, formInitialValues);
      const diffWithSymmetric = getDeviceDiff(symmetricDiff, devicesDiff);

      if (devicesDiff.length) {
        dispatch(setAddedDevices(devicesDiff));
      }

      if (diffWithSymmetric.length) {
        dispatch(setRemovedDevices(diffWithSymmetric));
      }
    } else {
      const addedDevices = getDeviceDiff(formDevices, formInitialValues);
      const removedDevices = getDeviceDiff(formInitialValues, formDevices);

      if (addedDevices.length) {
        dispatch(setAddedDevices(addedDevices));
      }

      if (removedDevices.length) {
        dispatch(setRemovedDevices(removedDevices));
      }
    }

    refetchDataRef.current = true;
  }, [
    addMode,
    dispatch,
    projectId,
    formDevicesJson,
    openedFromForm,
    formInitialValuesJson,
    renderRef,
    emptyForm,
    refetchDataRef
  ]);
};
